(function () {
'use strict';

var finderRoot = document.getElementById('PlayforceDeviceRecommendation');
if (!finderRoot) return;

var heroAccent = finderRoot.querySelector('.pf-dr-hero__accent');
var intentWarn = finderRoot.querySelector('#intentWarn');
var selectionArea = finderRoot.querySelector('#selectionArea');
var selectionWarn = finderRoot.querySelector('#selectionWarn');
var loadArea = finderRoot.querySelector('#loadArea');
var loadSelections = finderRoot.querySelector('#loadSelections');
var loadSelectionItems = finderRoot.querySelector('#loadSelectionItems');
var recommendationSelections = finderRoot.querySelector('#recommendationSelections');
var results = finderRoot.querySelector('#results');

var deviceRecoAssets = window.PlayforceDeviceRecoAssets || {};

function escapeAssetAttribute(value) {
 return String(value || '')
   .replace(/&/g, '&amp;')
   .replace(/"/g, '&quot;')
   .replace(/</g, '&lt;')
   .replace(/>/g, '&gt;');
}

function itemInitials(name) {
 var words = String(name || '')
   .replace(/[—/:+]/g, ' ')
   .replace(/\b(Adobe|Autodesk|Microsoft|EA|SPORTS)\b/gi, ' ')
   .trim()
   .split(/\s+/)
   .filter(Boolean);

 if (!words.length) return '?';
 if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
 return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
}

function itemIconMarkup(name, size) {
 var src = deviceRecoAssets[name];
 var mini = size === 'mini';
 var cls = mini
   ? 'pf-dr-item-icon pf-dr-item-icon--mini'
   : 'pf-dr-item-icon';

 if (src) {
   return `<span class="${cls}" aria-hidden="true"><img src="${escapeAssetAttribute(src)}" alt="" loading="lazy" decoding="async" width="${mini ? 22 : 48}" height="${mini ? 22 : 48}"></span>`;
 }

 return `<span class="${cls} pf-dr-item-icon--fallback" aria-hidden="true">${itemInitials(name)}</span>`;
}


const DATA={"appCategories":{"Work / Study":["Microsoft Office","AI Tools — ChatGPT / Gemini / Claude","Zoom / Teams / Google Meet","Chrome / Edge / Firefox","Exam / LockDown Browser"],"Work / Development":["Python / Coding","Visual Studio Code","Visual Studio","Docker","SQL / Database","Ubuntu OS"],"Engineering / Technical":["MATLAB"],"Design":["Canva","Figma","Adobe Photoshop","Adobe Illustrator","Adobe Lightroom","Adobe InDesign"],"Video":["CapCut","Adobe Premiere Pro","DaVinci Resolve","Final Cut Pro","Adobe After Effects","Wondershare Filmora","iMovie"],"Engineering / CAD":["AutoCAD","SOLIDWORKS","Autodesk Revit","Autodesk Fusion","SketchUp"]},"gameNames":["Roblox","Minecraft","League of Legends","Dota 2","Valorant","Counter-Strike 2","Overwatch 2","Fortnite","Grand Theft Auto V","Apex Legends","PUBG: BATTLEGROUNDS","Rainbow Six Siege","Marvel Rivals","EA SPORTS FC 26","Forza Horizon 5","Rust","Palworld","Call of Duty / Warzone","Elden Ring","Helldivers 2","Monster Hunter Wilds","Black Myth: Wukong","Hogwarts Legacy","Cyberpunk 2077","Microsoft Flight Simulator"],"intentGroups":{"workstudy":["Work / Study"],"development":["Work / Development"],"design":["Design"],"video":["Video"],"engineering":["Engineering / Technical","Engineering / CAD"]},"workloadDesc":{"workstudy":[["Light","Documents, browsing, meetings or study."],["Moderate","Regular multitasking and larger files."],["Heavy","Sustained multitasking and demanding work."]],"development":[["Light","Scripts, coursework and small projects."],["Moderate","Regular development and local services."],["Heavy","Large builds, containers or databases."]],"design":[["Light","Simple graphics and basic edits."],["Moderate","Larger files and regular creative work."],["Heavy","Large layered files and high-resolution work."]],"video":[["Light","Simple edits and shorter HD projects."],["Moderate","HD/4K editing, effects and exports."],["Heavy","Complex 4K+ projects and heavy effects."]],"engineering":[["Light","2D drawings, coursework or small models."],["Moderate","3D work and larger professional projects."],["Heavy","Large assemblies, BIM or simulation."]],"gaming":[["Standard","Smooth gameplay at sensible settings."],["High Performance","Higher frame rates and visual settings."],["Maximum Headroom","For demanding games and highest settings."]],"ipad":[["Light","Streaming, browsing, note-taking or occasional POS use."],["Moderate","Regular POS, creative apps, multitasking or gaming."],["Heavy","Demanding creative work, intensive multitasking or games."]]},"appWorkloadKeyByName":{"Microsoft Office":"workstudy","AI Tools — ChatGPT / Gemini / Claude":"workstudy","Zoom / Teams / Google Meet":"workstudy","Chrome / Edge / Firefox":"workstudy","Exam / LockDown Browser":"workstudy","Python / Coding":"development","Visual Studio Code":"development","Visual Studio":"development","Docker":"development","SQL / Database":"development","Ubuntu OS":"development","MATLAB":"engineering","Canva":"design","Figma":"design","Adobe Photoshop":"design","Adobe Illustrator":"design","Adobe Lightroom":"design","Adobe InDesign":"design","CapCut":"video","Adobe Premiere Pro":"video","DaVinci Resolve":"video","Final Cut Pro":"video","Adobe After Effects":"video","Wondershare Filmora":"video","iMovie":"video","AutoCAD":"engineering","SOLIDWORKS":"engineering","Autodesk Revit":"engineering","Autodesk Fusion":"engineering","SketchUp":"engineering"},"ipadAll":{"stream":{"name":"Watch video / streaming","kind":"use"},"browse_ipad":{"name":"Web browsing","kind":"use"},"notes":{"name":"Study / note-taking","kind":"use"},"prod_ipad":{"name":"Office / productivity","kind":"use"},"calls_ipad":{"name":"Video calls / meetings","kind":"use"},"pos":{"name":"POS / Retail Counter","kind":"use"},"draw":{"name":"Drawing / illustration","kind":"use"},"photo_ipad":{"name":"Photo editing","kind":"use"},"video_ipad":{"name":"Video editing","kind":"use"},"gaming_ipad":{"name":"Gaming","kind":"use"},"icasual":{"name":"Casual / puzzle games","kind":"game"},"iroblox":{"name":"Roblox","kind":"game"},"iminecraft":{"name":"Minecraft","kind":"game"},"fc_mobile":{"name":"EA SPORTS FC Mobile","kind":"game"},"freefire":{"name":"Free Fire MAX","kind":"game"},"pubg_mobile":{"name":"PUBG Mobile","kind":"game"},"fortnite_ipad":{"name":"Fortnite","kind":"game"},"genshin":{"name":"Genshin Impact","kind":"game"},"honkai":{"name":"Honkai: Star Rail","kind":"game"},"codm":{"name":"Call of Duty Mobile","kind":"game"},"asphalt":{"name":"Asphalt Legends","kind":"game"},"wuthering":{"name":"Wuthering Waves","kind":"game"}},"ipadUses":["stream","browse_ipad","notes","prod_ipad","calls_ipad","pos","draw","photo_ipad","video_ipad","gaming_ipad"],"ipadGames":["icasual","iroblox","iminecraft","fc_mobile","freefire","pubg_mobile","fortnite_ipad","genshin","honkai","codm","asphalt","wuthering"]};
let step=1;

const TIERS=['base','recommended','performance'];
const RECOMMENDATION_WORKER_URL='https://playforce-device-reco.digidr.workers.dev/recommend';

const DEVICE_INVENTORY_HANDLE_CANDIDATES={
 'Business Laptop — Intel Core i5 10th Gen / Ryzen 5 Equivalent':['security-deposit-business-i5','security-deposit-i5'],
 'Business Laptop — Intel Core i7 11th Gen / Ryzen 7 Equivalent':['security-deposit-business-i7','security-deposit-i7'],
 'Business Laptop — Core Ultra 5 / Ryzen 5 (New)':['security-deposit-ultra-5-ryzen-5-new','security-deposit-ultra-5'],
 'Business Laptop — Core Ultra 7 / Ryzen 7 (New)':['security-deposit-ultra-7-ryzen-7-new','security-deposit-ultra-7'],

 'Gaming Laptop — GTX 1650':['security-deposit-gtx-1650'],
 'Gaming Laptop — RTX 2060':['security-deposit-rtx-2060'],
 'Gaming Laptop — RTX 3050':['security-deposit-rtx-3050'],
 'Gaming Laptop — RTX 3060':['security-deposit-rtx-3060','security-deposit-rtx-3060-below'],
 'Gaming Laptop — RTX 3070':['security-deposit-rtx-3070'],
 'Gaming Laptop — RTX 3080':['security-deposit-rtx-3080'],
 'Gaming Laptop — RTX 4050':['security-deposit-rtx-4050'],
 'Gaming Laptop — RTX 4060':['security-deposit-rtx-4060'],
 'Gaming Laptop — RTX 4070':['security-deposit-rtx-4070'],
 'Gaming Laptop — RTX 5050':['security-deposit-rtx-5050'],
 'Gaming Laptop — RTX 5060':['security-deposit-rtx-5060'],
 'Gaming Laptop — RTX 5070':['security-deposit-rtx-5070'],
 'Gaming Laptop — RTX 5080':['security-deposit-rtx-5080'],

 'MacBook Air M1':['security-deposit-macbook-air-m1'],
 'MacBook Air M2':['security-deposit-macbook-air-m2'],
 'MacBook Air M3':['security-deposit-macbook-air-m3'],
 'MacBook Air M4':['security-deposit-macbook-air-m4'],
 'MacBook Air M5':['security-deposit-macbook-air-m5'],
 'MacBook Pro M1':['security-deposit-macbook-pro-m1'],
 'MacBook Pro M2':['security-deposit-macbook-pro-m2'],
 'MacBook Pro M1 Pro':['security-deposit-macbook-pro-m1-pro'],
 'MacBook Pro M2 Pro':['security-deposit-macbook-pro-m2-pro'],
 'MacBook Pro M3 Pro':['security-deposit-macbook-pro-m3-pro'],
 'MacBook Pro M4 Pro':['security-deposit-macbook-pro-m4-pro'],
 'MacBook Pro M5 Pro':['security-deposit-macbook-pro-m5-pro','security-deposit-m5-pro'],
 'MacBook Pro M3 Max':['security-deposit-macbook-pro-m3-max'],

 'iPad 8th Gen':['security-deposit-ipad-8th','security-deposit-ipad-8th-cellular'],
 'iPad 9th Gen':['security-deposit-ipad-9th','security-deposit-ipad-9th-cellular'],
 'iPad 10th Gen':['security-deposit-ipad-10th','security-deposit-ipad-10th-cellular'],
 'iPad 11th Gen':['security-deposit-ipad-11th','security-deposit-ipad-11th-cellular'],
 'iPad Air M1':['security-deposit-ipad-air-m1','security-deposit-ipad-air-5th','security-deposit-ipad-air-m1-cellular','security-deposit-ipad-air-5th-cellular'],
 'iPad Air M4':['security-deposit-ipad-air-m4','security-deposit-ipad-air-m4-cellular'],
 'iPad Pro M1':['security-deposit-ipad-pro-m1','security-deposit-ipad-m1','security-deposit-ipad-pro-m1-cellular','security-deposit-ipad-m1-cellular'],
 'iPad Pro M2':['security-deposit-ipad-pro-m2','security-deposit-ipad-m2','security-deposit-ipad-pro-m2-cellular','security-deposit-ipad-m2-cellular'],
 'iPad Pro M4':['security-deposit-ipad-pro-m4','security-deposit-ipad-m4','security-deposit-ipad-pro-m4-cellular','security-deposit-ipad-m4-cellular']
};

const DEVICE_INVENTORY_VARIANT_IDS={
 'Business Laptop — Intel Core i5 10th Gen / Ryzen 5 Equivalent':['47994120241339'],
 'Business Laptop — Intel Core i7 11th Gen / Ryzen 7 Equivalent':['47994120339643'],
 'Business Laptop — Core Ultra 5 / Ryzen 5 (New)':['48111443509435'],
 'Business Laptop — Core Ultra 7 / Ryzen 7 (New)':['48111444099259'],

 'Gaming Laptop — GTX 1650':['48000206274747'],
 'Gaming Laptop — RTX 2060':['48000206700731'],
 'Gaming Laptop — RTX 3050':['48000207061179'],
 'Gaming Laptop — RTX 3060':['48000207388859'],
 'Gaming Laptop — RTX 3070':['48000136282299'],
 'Gaming Laptop — RTX 3080':['48000145031355'],
 'Gaming Laptop — RTX 4050':['47939105030331'],
 'Gaming Laptop — RTX 4060':['47939105980603'],
 'Gaming Laptop — RTX 4070':['47939106078907'],
 'Gaming Laptop — RTX 5050':['48205548290235'],
 'Gaming Laptop — RTX 5080':['48221763272891'],

 'MacBook Air M1':['47939187343547'],
 'MacBook Air M2':['47939187605691'],
 'MacBook Air M4':['47939187671227'],
 'MacBook Pro M1':['47939188719803'],
 'MacBook Pro M2':['47939189276859'],
 'MacBook Pro M1 Pro':['47939190161595'],
 'MacBook Pro M2 Pro':['47939191931067'],
 'MacBook Pro M3 Pro':['47939192258747'],
 'MacBook Pro M3 Max':['48000175931579'],
 'MacBook Pro M4 Pro':['47939193307323'],
 'MacBook Pro M5 Pro':['48220744155323'],

 'iPad 8th Gen':['48012018843835','48199708836027'],
 'iPad 9th Gen':['47940834984123','48199708967099'],
 'iPad 10th Gen':['48011984797883','48199708999867'],
 'iPad 11th Gen':['48221678796987','48221681189051'],
 'iPad Air M1':['47940837474491','48199709163707'],
 'iPad Air M4':['48221653827771','48221655466171'],
 'iPad Pro M1':['47940838621371','48199710081211'],
 'iPad Pro M2':['47940843143355','48199710212283']
};

const INITIAL_INVENTORY_BY_HANDLE=(window.PlayforceDeviceRecoInventory&&window.PlayforceDeviceRecoInventory.byHandle)||{};
let recommendationInventoryCheckSequence=0;

const RECOMMENDATION_MONTHLY_PERIOD='1 Month';
const RECOMMENDATION_32GB_ADDON_VARIANT_ID='47939116859579';
const recommendationProductPricingCache=new Map();
const recommendationAddonPricingCache=new Map();
const recommendationMonthlyPriceByDevice=new Map();
let recommendation32GBAddonPriceCents=null;
let recommendationPricingPreloadStatus='idle';
let recommendationPricingPreloadPromise=null;
let recommendationMonthlyPriceSequence=0;

const DEVICE_RENTAL_PRODUCT_CONFIG={
 'Business Laptop — Intel Core i5 10th Gen / Ryzen 5 Equivalent':{
   path:'/products/business-laptop-rental',
   processor:'i5 / Ryzen 5'
 },
 'Business Laptop — Intel Core i7 11th Gen / Ryzen 7 Equivalent':{
   path:'/products/business-laptop-rental',
   processor:'i7 / Ryzen 7'
 },
 'Business Laptop — Core Ultra 5 / Ryzen 5 (New)':{
   path:'/products/business-laptop-rental',
   processor:'Ultra 5 / Ryzen 5 (New)'
 },
 'Business Laptop — Core Ultra 7 / Ryzen 7 (New)':{
   path:'/products/business-laptop-rental',
   processor:'Ultra 7 / Ryzen 7 (New)'
 },

 'Gaming Laptop — GTX 1650':{path:'/products/gaming-laptop-rental',processor:'GTX 1650'},
 'Gaming Laptop — RTX 2060':{path:'/products/gaming-laptop-rental',processor:'RTX 2060'},
 'Gaming Laptop — RTX 3050':{path:'/products/gaming-laptop-rental',processor:'RTX 3050'},
 'Gaming Laptop — RTX 3060':{path:'/products/gaming-laptop-rental',processor:'RTX 3060'},
 'Gaming Laptop — RTX 3070':{path:'/products/gaming-laptop-rental',processor:'RTX 3070'},
 'Gaming Laptop — RTX 3080':{path:'/products/gaming-laptop-rental',processor:'RTX 3080'},
 'Gaming Laptop — RTX 4050':{path:'/products/gaming-laptop-rental',processor:'RTX 4050'},
 'Gaming Laptop — RTX 4060':{path:'/products/gaming-laptop-rental',processor:'RTX 4060'},
 'Gaming Laptop — RTX 4070':{path:'/products/gaming-laptop-rental',processor:'RTX 4070'},
 'Gaming Laptop — RTX 5050':{path:'/products/gaming-laptop-rental',processor:'RTX 5050'},
 'Gaming Laptop — RTX 5060':{path:'/products/gaming-laptop-rental',processor:'RTX 5060'},
 'Gaming Laptop — RTX 5070':{path:'/products/gaming-laptop-rental',processor:'RTX 5070'},
 'Gaming Laptop — RTX 5080':{path:'/products/gaming-laptop-rental',processor:'RTX 5080'},

 'MacBook Air M1':{path:'/products/macbook-rental',processor:'MacBook Air M1'},
 'MacBook Air M2':{path:'/products/macbook-rental',processor:'MacBook Air M2'},
 'MacBook Air M3':{path:'/products/macbook-rental',processor:'MacBook Air M3'},
 'MacBook Air M4':{path:'/products/macbook-rental',processor:'MacBook Air M4'},
 'MacBook Air M5':{path:'/products/macbook-rental',processor:'MacBook Air M5'},
 'MacBook Pro M1':{path:'/products/macbook-rental',processor:'MacBook Pro M1'},
 'MacBook Pro M2':{path:'/products/macbook-rental',processor:'MacBook Pro M2'},
 'MacBook Pro M1 Pro':{path:'/products/macbook-rental',processor:'MacBook Pro M1 Pro'},
 'MacBook Pro M2 Pro':{path:'/products/macbook-rental',processor:'MacBook Pro M2 Pro'},
 'MacBook Pro M3 Pro':{path:'/products/macbook-rental',processor:'MacBook Pro M3 Pro'},
 'MacBook Pro M4 Pro':{path:'/products/macbook-rental',processor:'MacBook Pro M4 Pro'},
 'MacBook Pro M5 Pro':{path:'/products/macbook-rental',processor:'MacBook Pro M5 Pro'},
 'MacBook Pro M3 Max':{path:'/products/macbook-rental',processor:'MacBook Pro M3 Max'},

 'iPad 8th Gen':{path:'/products/ipad-rental',processor:'iPad 8th'},
 'iPad 9th Gen':{path:'/products/ipad-rental',processor:'iPad 9th'},
 'iPad 10th Gen':{path:'/products/ipad-rental',processor:'iPad 10th'},
 'iPad 11th Gen':{path:'/products/ipad-rental',processor:'iPad 11th'},
 'iPad Air M1':{path:'/products/ipad-rental',processor:'iPad Air M1'},
 'iPad Air M4':{path:'/products/ipad-rental',processor:'iPad Air M4'},
 'iPad Pro M1':{path:'/products/ipad-rental',processor:'iPad Pro M1'},
 'iPad Pro M2':{path:'/products/ipad-rental',processor:'iPad Pro M2'},
 'iPad Pro M4':{path:'/products/ipad-rental',processor:'iPad Pro M4'}
};

function recommendationProductUrlForDevice(deviceName){
 const config=DEVICE_RENTAL_PRODUCT_CONFIG[deviceName];
 if(!config)return '';

 return config.path+'?pf_processor='+encodeURIComponent(config.processor)+'&pf_period='+encodeURIComponent(RECOMMENDATION_MONTHLY_PERIOD)+'&from=device-recommendation';
}

function recommendationDeviceForBand(band,statusLookup){
 const devices=inventoryDeviceNamesForBand(band);
 if(!devices.length)return '';

 if(typeof statusLookup==='function'){
   const available=devices.find(deviceName=>statusLookup(deviceName)==='available');
   if(available)return available;
 }

 return devices[0];
}

function recommendationProductUrlForBand(band,statusLookup){
 const deviceName=recommendationDeviceForBand(band,statusLookup);
 return deviceName?recommendationProductUrlForDevice(deviceName):'';
}

function normaliseRecommendationPricingValue(value){
 return String(value||'')
   .trim()
   .replace(/\s+/g,' ')
   .toLowerCase();
}

function recommendationVariantOptions(variant){
 if(!variant||typeof variant!=='object')return [];
 if(Array.isArray(variant.options))return variant.options.map(value=>String(value||'').trim());

 return [variant.option1,variant.option2,variant.option3]
   .filter(value=>value!==undefined&&value!==null&&String(value).trim()!=='')
   .map(value=>String(value).trim());
}

function recommendationIsOneMonthOption(value){
 return /^1\s*month$/i.test(String(value||'').trim());
}

function recommendationProcessorOptionMatches(candidate,target){
 const candidateKey=normaliseRecommendationPricingValue(candidate);
 const targetKey=normaliseRecommendationPricingValue(target);

 if(!candidateKey||!targetKey)return false;
 if(candidateKey===targetKey)return true;

 if(/^ipad\b/.test(targetKey)){
   const candidateWithoutWifi=candidateKey
     .replace(/\s+(?:wi[\s-]?fi|wifi)\s*$/i,'')
     .trim();

   if(candidateWithoutWifi===targetKey&&!/\bcellular\b/i.test(candidateKey)){
     return true;
   }
 }

 return false;
}

function recommendationProductJsonUrl(path){
 const clean=String(path||'').replace(/\/+$/,'');
 return clean?clean+'.js?device_reco_price='+Date.now():'';
}

function fetchRecommendationPricingProduct(path){
 const cacheKey=String(path||'');
 if(!cacheKey)return Promise.resolve(null);

 if(recommendationProductPricingCache.has(cacheKey)){
   return recommendationProductPricingCache.get(cacheKey);
 }

 const url=recommendationProductJsonUrl(cacheKey);
 if(!url)return Promise.resolve(null);

 const request=fetch(url,{
   method:'GET',
   headers:{'Accept':'application/json','Cache-Control':'no-cache'},
   cache:'no-store'
 })
   .then(response=>{
     if(!response.ok)throw new Error('Unable to read rental product pricing.');
     return response.json();
   })
   .catch(()=>null);

 recommendationProductPricingCache.set(cacheKey,request);
 return request;
}

function recommendationMonthlyVariantForProcessor(product,processor){
 if(!product||!Array.isArray(product.variants))return null;

 const candidates=product.variants.filter(variant=>{
   const options=recommendationVariantOptions(variant);

   return options.some(recommendationIsOneMonthOption) &&
     options.some(option=>recommendationProcessorOptionMatches(option,processor));
 });

 if(!candidates.length)return null;

 return candidates.find(variant=>variant.available!==false)||candidates[0]||null;
}

function fetchRecommendationBaseMonthlyPriceCents(deviceName){
 const config=DEVICE_RENTAL_PRODUCT_CONFIG[deviceName];
 if(!config||!config.path||!config.processor)return Promise.resolve(null);

 return fetchRecommendationPricingProduct(config.path)
   .then(product=>{
     const variant=recommendationMonthlyVariantForProcessor(product,config.processor);
     const cents=Number(variant&&variant.price);
     return Number.isFinite(cents)?cents:null;
   });
}

function fetchRecommendationAddonVariantPriceCents(variantId){
 const key=String(variantId||'');
 if(!key)return Promise.resolve(null);

 if(recommendationAddonPricingCache.has(key)){
   return recommendationAddonPricingCache.get(key);
 }

 const request=fetch('/variants/'+encodeURIComponent(key)+'.js?device_reco_price='+Date.now(),{
   method:'GET',
   headers:{'Accept':'application/json','Cache-Control':'no-cache'},
   cache:'no-store'
 })
   .then(response=>{
     if(!response.ok)throw new Error('Unable to read recommendation add-on pricing.');
     return response.json();
   })
   .then(variant=>{
     const cents=Number(variant&&variant.price);
     return Number.isFinite(cents)?cents:null;
   })
   .catch(()=>null);

 recommendationAddonPricingCache.set(key,request);
 return request;
}

function recommendationBandNeeds32GBAddon(band,deviceName){
 const text=String(band||'');
 if(!/32GB\s*RAM/i.test(text))return false;
 if(!/^Gaming Laptop —/i.test(String(deviceName||'')))return false;

 return !/RTX\s*(?:5070|5080)\b/i.test(String(deviceName||''));
}

function preloadRecommendationMonthlyPricing(){
 if(recommendationPricingPreloadPromise){
   return recommendationPricingPreloadPromise;
 }

 recommendationPricingPreloadStatus='loading';

 const uniquePaths=[
   ...new Set(
     Object.values(DEVICE_RENTAL_PRODUCT_CONFIG)
       .map(config=>config&&config.path)
       .filter(Boolean)
   )
 ];

 const productRequests=uniquePaths.map(path=>
   fetchRecommendationPricingProduct(path).then(product=>[path,product])
 );

 const addonRequest=fetchRecommendationAddonVariantPriceCents(
   RECOMMENDATION_32GB_ADDON_VARIANT_ID
 );

 recommendationPricingPreloadPromise=Promise.all([
   Promise.all(productRequests),
   addonRequest
 ])
   .then(([productEntries,addonCents])=>{
     const productByPath=new Map(productEntries);

     recommendationMonthlyPriceByDevice.clear();

     Object.entries(DEVICE_RENTAL_PRODUCT_CONFIG).forEach(([deviceName,config])=>{
       if(!config||!config.path||!config.processor)return;

       const product=productByPath.get(config.path);
       const variant=recommendationMonthlyVariantForProcessor(
         product,
         config.processor
       );
       const cents=Number(variant&&variant.price);

       if(Number.isFinite(cents)){
         recommendationMonthlyPriceByDevice.set(deviceName,cents);
       }
     });

     recommendation32GBAddonPriceCents=Number.isFinite(addonCents)
       ?addonCents
       :null;

     const expectedDeviceCount=Object.keys(DEVICE_RENTAL_PRODUCT_CONFIG).length;
     recommendationPricingPreloadStatus=
       recommendationMonthlyPriceByDevice.size===expectedDeviceCount
         ?'ready'
         :'partial';

     return {
       status:recommendationPricingPreloadStatus,
       prices:recommendationMonthlyPriceByDevice,
       addonCents:recommendation32GBAddonPriceCents
     };
   })
   .catch(()=>{
     recommendationPricingPreloadStatus='partial';
     return {
       status:'partial',
       prices:recommendationMonthlyPriceByDevice,
       addonCents:recommendation32GBAddonPriceCents
     };
   });

 return recommendationPricingPreloadPromise;
}

function recommendationMonthlyPriceCentsFromCache(band,deviceName){
 const resolvedDevice=deviceName||recommendationDeviceForBand(band);
 if(!resolvedDevice)return null;

 const baseCents=recommendationMonthlyPriceByDevice.get(resolvedDevice);
 if(!Number.isFinite(baseCents))return null;

 if(!recommendationBandNeeds32GBAddon(band,resolvedDevice)){
   return baseCents;
 }

 if(!Number.isFinite(recommendation32GBAddonPriceCents))return null;
 return baseCents+recommendation32GBAddonPriceCents;
}

function fetchRecommendationMonthlyPriceCents(band,deviceName){
 const cached=recommendationMonthlyPriceCentsFromCache(band,deviceName);
 if(Number.isFinite(cached))return Promise.resolve(cached);

 return preloadRecommendationMonthlyPricing().then(()=>
   recommendationMonthlyPriceCentsFromCache(band,deviceName)
 );
}

const recommendationPricingReady=preloadRecommendationMonthlyPricing();

function recommendationPricingPayload(){
 const devicePrices={};

 recommendationMonthlyPriceByDevice.forEach((cents,deviceName)=>{
   if(Number.isFinite(cents)){
     devicePrices[deviceName]=Math.round(cents);
   }
 });

 const pricing={devicePrices};

 if(Number.isFinite(recommendation32GBAddonPriceCents)){
   pricing.addon32gbCents=Math.round(recommendation32GBAddonPriceCents);
 }

 return pricing;
}

async function fetchServerRecommendation(payload){
 const controller=typeof AbortController!=='undefined'
   ?new AbortController()
   :null;
 const timeout=controller
   ?setTimeout(()=>controller.abort(),12000)
   :null;

 try{
   const response=await fetch(RECOMMENDATION_WORKER_URL,{
     method:'POST',
     headers:{'Content-Type':'application/json'},
     body:JSON.stringify(payload),
     ...(controller?{signal:controller.signal}:{})
   });

   let data=null;
   try{
     data=await response.json();
   }catch(_){
     data=null;
   }

   if(!response.ok||!data||data.success!==true){
     throw new Error(
       data&&data.error
         ?String(data.error)
         :'Unable to load device recommendation.'
     );
   }

   return data;
 }finally{
   if(timeout)clearTimeout(timeout);
 }
}

function formatRecommendationMonthlyPrice(cents){
 const value=Number(cents)/100;
 if(!Number.isFinite(value))return '';

 const hasCents=Math.round(value*100)%100!==0;
 return 'S$'+value.toLocaleString('en-SG',{
   minimumFractionDigits:hasCents?2:0,
   maximumFractionDigits:2
 });
}

function recommendationDeviceNameForPriceCard(card){
 if(!card)return '';

 const current=card.getAttribute('data-pf-dr-device-name')||'';
 if(current&&DEVICE_RENTAL_PRODUCT_CONFIG[current])return current;

 const band=card.getAttribute('data-pf-dr-band')||'';
 return recommendationDeviceForBand(band);
}

function applyRecommendationMonthlyPrice(card,cents){
 if(!card)return;

 const priceEl=card.querySelector('.pf-dr-monthly-price');
 if(!priceEl)return;

 let resolvedCents=Number(cents);

 if(!Number.isFinite(resolvedCents)){
   const fallbackCents=Number(
     card.getAttribute('data-pf-dr-affordable-price-cents')
   );
   const fallbackDevice=
     card.getAttribute('data-pf-dr-affordable-price-device')||'';
   const currentDevice=recommendationDeviceNameForPriceCard(card);

   if(
     Number.isFinite(fallbackCents)&&
     fallbackDevice&&
     currentDevice===fallbackDevice
   ){
     resolvedCents=fallbackCents;
   }
 }

 if(!Number.isFinite(resolvedCents)){
   priceEl.hidden=true;
   priceEl.textContent='';
   card.removeAttribute('data-pf-dr-monthly-price-cents');
   return;
 }

 const formatted=formatRecommendationMonthlyPrice(resolvedCents);
 if(!formatted){
   priceEl.hidden=true;
   return;
 }

 card.setAttribute('data-pf-dr-monthly-price-cents',String(resolvedCents));
 priceEl.innerHTML=`<strong>${formatted}</strong><span>/ month</span>`;
 priceEl.hidden=false;
}


let recommendationCardAlignFrame=0;

function alignRecommendationCardContents(){
 if(!results)return;

 if(recommendationCardAlignFrame){
   cancelAnimationFrame(recommendationCardAlignFrame);
 }

 recommendationCardAlignFrame=requestAnimationFrame(()=>{
   recommendationCardAlignFrame=0;
   const stacked=window.matchMedia('(max-width: 767px)').matches;

   results.querySelectorAll(
     '.pf-dr-recommend-strip, .pf-dr-affordable-strip'
   ).forEach(strip=>{
     const cards=Array.from(strip.children).filter(card=>
       card.matches('.pf-dr-recommend-segment, .pf-dr-affordable-segment')
     );

     cards.forEach(card=>{
       card.style.removeProperty('--pf-dr-aligned-title-h');
       card.style.removeProperty('--pf-dr-aligned-copy-h');
     });

     if(stacked||cards.length<2)return;

     let titleHeight=0;
     let copyHeight=0;

     cards.forEach(card=>{
       const title=card.querySelector('h4');
       const copy=card.querySelector('p');

       if(title){
         titleHeight=Math.max(
           titleHeight,
           title.getBoundingClientRect().height
         );
       }

       if(copy&&!copy.hidden){
         copyHeight=Math.max(
           copyHeight,
           copy.getBoundingClientRect().height
         );
       }
     });

     titleHeight=Math.ceil(titleHeight);
     copyHeight=Math.ceil(copyHeight);

     cards.forEach(card=>{
       if(titleHeight){
         card.style.setProperty(
           '--pf-dr-aligned-title-h',
           titleHeight+'px'
         );
       }

       if(copyHeight&&card.querySelector('p')){
         card.style.setProperty(
           '--pf-dr-aligned-copy-h',
           copyHeight+'px'
         );
       }
     });
   });
 });
}

function refreshRecommendationMonthlyPricing(){
 if(!results)return Promise.resolve();

 const sequence=++recommendationMonthlyPriceSequence;
 const cards=Array.from(results.querySelectorAll(
   '.result[data-pf-dr-band], .pf-dr-affordable-segment[data-pf-dr-band]'
 ));

 if(!cards.length)return Promise.resolve();

 return Promise.all(cards.map(card=>{
   const band=card.getAttribute('data-pf-dr-band')||'';
   const deviceName=recommendationDeviceNameForPriceCard(card);

   return fetchRecommendationMonthlyPriceCents(band,deviceName)
     .then(cents=>[card,cents]);
 }))
   .then(entries=>{
     if(sequence!==recommendationMonthlyPriceSequence)return;

     entries.forEach(([card,cents])=>{
       applyRecommendationMonthlyPrice(card,cents);
     });
     alignRecommendationCardContents();
   })
   .catch(()=>{
     alignRecommendationCardContents();
   });
}

function applyResultProductLink(card,statusLookup){
 if(!card)return;

 const band=card.getAttribute('data-pf-dr-band')||'';
 const deviceName=recommendationDeviceForBand(band,statusLookup);
 const url=deviceName?recommendationProductUrlForDevice(deviceName):'';

 if(deviceName){
   card.setAttribute('data-pf-dr-device-name',deviceName);
 }else{
   card.removeAttribute('data-pf-dr-device-name');
 }

 if(url){
   card.setAttribute('href',url);
   card.setAttribute('aria-label','Rent '+band);
   card.classList.add('pf-dr-result-link');
 }else{
   card.removeAttribute('href');
   card.removeAttribute('aria-label');
   card.classList.remove('pf-dr-result-link');
 }
}

function inventoryDeviceNamesForBand(band){
 const text=String(band||'');
 if(!text||/^N\/A\b/i.test(text))return [];

 const out=[];
 function add(name){
   if(name&&DEVICE_INVENTORY_HANDLE_CANDIDATES[name]&&!out.includes(name))out.push(name);
 }

 if(text.startsWith('Business Laptop')){
   if(/Core Ultra 7|Ryzen 7 \(New\)/i.test(text))add('Business Laptop — Core Ultra 7 / Ryzen 7 (New)');
   else if(/Core Ultra 5|Ryzen 5 \(New\)/i.test(text))add('Business Laptop — Core Ultra 5 / Ryzen 5 (New)');
   else if(/Core i7|Ryzen 7 Equivalent/i.test(text))add('Business Laptop — Intel Core i7 11th Gen / Ryzen 7 Equivalent');
   else if(/Core i5|Ryzen 5 Equivalent/i.test(text))add('Business Laptop — Intel Core i5 10th Gen / Ryzen 5 Equivalent');
   return out;
 }

 const gpuMatches=text.match(/\b(?:GTX 1650|RTX (?:2060|3050|3060|3070|3080|4050|4060|4070|5050|5060|5070|5080))\b/gi)||[];
 gpuMatches.forEach(gpu=>add('Gaming Laptop — '+gpu.toUpperCase()));

 const macMatches=text.match(/MacBook (?:Air M[1-5]|Pro M3 Max|Pro M[1-5] Pro|Pro M[1-5])/g)||[];
 macMatches.forEach(add);

 const ipadMatches=text.match(/iPad (?:Air M(?:1|4)|Pro M(?:1|2|4)|(?:8th|9th|10th|11th) Gen)/g)||[];
 ipadMatches.forEach(add);

 return out;
}

function initialHandleProductAvailable(product){
 if(!product||!Array.isArray(product.variants)||!product.variants.length)return null;
 let sawKnown=false;

 for(const variant of product.variants){
   if(!variant||typeof variant!=='object')continue;
   sawKnown=true;

   if(typeof variant.availableQty==='number'){
     if(variant.availableQty>0&&variant.available!==false)return true;
     continue;
   }

   if(variant.available!==false)return true;
 }

 return sawKnown?false:null;
}

function existingInitialHandlesForDevice(deviceName){
 const candidates=DEVICE_INVENTORY_HANDLE_CANDIDATES[deviceName]||[];
 const existing=candidates.filter(handle=>Object.prototype.hasOwnProperty.call(INITIAL_INVENTORY_BY_HANDLE,handle));
 return existing.length?existing:candidates;
}

function initialDeviceInventoryStatus(deviceName){
 const handles=existingInitialHandlesForDevice(deviceName);
 let sawKnown=false;
 let sawUnknown=false;

 for(const handle of handles){
   const product=INITIAL_INVENTORY_BY_HANDLE[handle];

   if(!product){
     sawUnknown=true;
     continue;
   }

   const available=initialHandleProductAvailable(product);
   if(available===true)return 'available';
   if(available===false)sawKnown=true;
   else sawUnknown=true;
 }

 if(sawKnown&&!sawUnknown)return 'unavailable';
 return 'unknown';
}

function combineDeviceStatuses(deviceNames,statusLookup){
 if(!deviceNames.length)return 'unknown';

 let sawUnknown=false;
 for(const deviceName of deviceNames){
   const status=statusLookup(deviceName);
   if(status==='available')return 'available';
   if(status!=='unavailable')sawUnknown=true;
 }

 return sawUnknown?'unknown':'unavailable';
}

function applyResultInventoryStatus(card,status){
 if(!card)return;

 const note=card.querySelector('.pf-dr-stock-status');
 const unavailable=status==='unavailable';

 card.classList.toggle('is-stock-unavailable',unavailable);
 card.setAttribute('data-pf-dr-stock-status',status||'unknown');

 if(note){
   note.hidden=!unavailable;
   note.textContent=unavailable?'Unavailable for now':'';
 }
}

function recommendationInventoryCards(){
 if(!results)return [];

 return Array.from(results.querySelectorAll(
   '.result[data-pf-dr-band], .pf-dr-affordable-segment[data-pf-dr-band]'
 ));
}

function applyInitialRecommendationInventory(){
 const cards=recommendationInventoryCards();

 cards.forEach(card=>{
   const devices=inventoryDeviceNamesForBand(card.getAttribute('data-pf-dr-band'));
   const status=combineDeviceStatuses(devices,initialDeviceInventoryStatus);
   applyResultInventoryStatus(card,status);
   applyResultProductLink(card,initialDeviceInventoryStatus);
 });
}

function fetchRecommendationCartQuantities(){
 return fetch('/cart.js?device_reco_stock='+Date.now(),{
   method:'GET',
   headers:{'Accept':'application/json','Cache-Control':'no-cache'},
   cache:'no-store'
 })
   .then(response=>{
     if(!response.ok)throw new Error('Unable to read cart quantities.');
     return response.json();
   })
   .then(cart=>{
     const quantities={};

     if(cart&&Array.isArray(cart.items)){
       cart.items.forEach(item=>{
         const variantId=String(item.variant_id||item.id||'');
         if(!variantId)return;

         quantities[variantId]=(quantities[variantId]||0)+Number(item.quantity||0);
       });
     }

     return quantities;
   })
   .catch(()=>({}));
}

function fetchInventoryProductByHandle(handle){
 return fetch('/products/'+encodeURIComponent(handle)+'.json?device_reco_stock='+Date.now(),{
   method:'GET',
   headers:{'Accept':'application/json','Cache-Control':'no-cache'},
   cache:'no-store'
 })
   .then(response=>{
     if(response.status===404)return null;
     if(!response.ok)throw new Error('Unable to read inventory product.');
     return response.json();
   })
   .then(payload=>{
     if(!payload)return null;
     return payload.product&&typeof payload.product==='object'?payload.product:payload;
   })
   .catch(()=>null);
}

function fetchInventoryVariantStatus(variantId,cartQuantities){
 return fetch('/variants/'+encodeURIComponent(variantId)+'.js?device_reco_stock='+Date.now(),{
   method:'GET',
   headers:{'Accept':'application/json','Cache-Control':'no-cache'},
   cache:'no-store'
 })
   .then(response=>{
     if(!response.ok)throw new Error('Unable to read inventory variant.');
     return response.json();
   })
   .then(variant=>{
     let available=variant.available!==false;
     const inventoryQuantity=typeof variant.inventory_quantity==='number'?variant.inventory_quantity:null;
     const inventoryManagement=variant.inventory_management||'';
     const inventoryPolicy=variant.inventory_policy||'';
     const quantityInCart=Number(cartQuantities[String(variantId)]||0);

     if(inventoryQuantity!==null&&inventoryManagement&&inventoryPolicy!=='continue'){
       available=(inventoryQuantity-quantityInCart)>0;
     }

     return {
       available,
       availableQty:inventoryQuantity===null?null:Math.max(inventoryQuantity-quantityInCart,0),
       unknown:false
     };
   })
   .catch(()=>({available:null,availableQty:null,unknown:true}));
}

function fetchHandleInventoryStatus(handle,cartQuantities){
 return fetchInventoryProductByHandle(handle).then(product=>{
   if(!product||!Array.isArray(product.variants)||!product.variants.length)return 'not-found';

   return Promise.all(product.variants.map(variant=>fetchInventoryVariantStatus(variant.id,cartQuantities)))
     .then(statuses=>{
       if(statuses.some(status=>status&&!status.unknown&&status.available===true))return 'available';
       if(statuses.some(status=>status&&status.unknown))return 'unknown';
       return 'unavailable';
     });
 });
}

function fetchDeviceInventoryStatus(deviceName,cartQuantities){
 const directVariantIds=DEVICE_INVENTORY_VARIANT_IDS[deviceName]||[];

 if(directVariantIds.length){
   return Promise.all(directVariantIds.map(variantId=>fetchInventoryVariantStatus(variantId,cartQuantities)))
     .then(statuses=>{
       if(statuses.some(status=>status&&!status.unknown&&status.available===true))return 'available';
       if(statuses.some(status=>status&&status.unknown))return 'unknown';
       return statuses.length?'unavailable':'unknown';
     })
     .catch(()=>initialDeviceInventoryStatus(deviceName));
 }

 const handles=existingInitialHandlesForDevice(deviceName);
 if(!handles.length)return Promise.resolve('unknown');

 return Promise.all(handles.map(handle=>fetchHandleInventoryStatus(handle,cartQuantities)))
   .then(statuses=>{
     if(statuses.includes('available'))return 'available';

     const meaningful=statuses.filter(status=>status!=='not-found');
     if(!meaningful.length)return 'unknown';
     if(meaningful.includes('unknown'))return 'unknown';

     return meaningful.every(status=>status==='unavailable')?'unavailable':'unknown';
   })
   .catch(()=>initialDeviceInventoryStatus(deviceName));
}

function refreshRecommendationInventory(){
 if(!results)return Promise.resolve();

 const sequence=++recommendationInventoryCheckSequence;
 const cards=recommendationInventoryCards();
 if(!cards.length)return Promise.resolve();

 applyInitialRecommendationInventory();
 refreshRecommendationMonthlyPricing();

 const deviceNames=[];
 cards.forEach(card=>{
   inventoryDeviceNamesForBand(card.getAttribute('data-pf-dr-band')).forEach(deviceName=>{
     if(!deviceNames.includes(deviceName))deviceNames.push(deviceName);
   });
 });

 if(!deviceNames.length)return refreshRecommendationMonthlyPricing();

 return fetchRecommendationCartQuantities()
   .then(cartQuantities=>Promise.all(deviceNames.map(deviceName=>
     fetchDeviceInventoryStatus(deviceName,cartQuantities)
       .then(status=>[deviceName,status])
   )))
   .then(entries=>{
     if(sequence!==recommendationInventoryCheckSequence)return;

     const liveByDevice=Object.fromEntries(entries);

     cards.forEach(card=>{
       const devices=inventoryDeviceNamesForBand(card.getAttribute('data-pf-dr-band'));
       const status=combineDeviceStatuses(devices,deviceName=>{
         const live=liveByDevice[deviceName];

         if(live&&live!=='unknown')return live;
         return initialDeviceInventoryStatus(deviceName);
       });

       applyResultInventoryStatus(card,status);
       applyResultProductLink(card,deviceName=>{
         const live=liveByDevice[deviceName];
         if(live&&live!=='unknown')return live;
         return initialDeviceInventoryStatus(deviceName);
       });
     });

     return refreshRecommendationMonthlyPricing();
   })
   .catch(()=>{
     return refreshRecommendationMonthlyPricing();
   });
}

const LEVEL_LABELS={
  workstudy:['Light','Moderate','Heavy'],
  development:['Light','Moderate','Heavy'],
  design:['Light','Moderate','Heavy'],
  video:['Light','Moderate','Heavy'],
  engineering:['Light','Moderate','Heavy'],
  gaming:['Standard','High Performance','Maximum Headroom'],
  ipad:['light','moderate','heavy']
};

function selected(root){return [...finderRoot.querySelectorAll(root+' input[type=checkbox]:checked')].map(x=>x.value)}
function syncCards(){
 finderRoot.querySelectorAll('.choice').forEach(x=>x.classList.toggle('selected',x.querySelector('input')?.checked));
 finderRoot.querySelectorAll('.radio').forEach(x=>x.classList.toggle('selected',x.querySelector('input')?.checked));
}
window.addEventListener('resize',alignRecommendationCardContents);

finderRoot.addEventListener('change',e=>{
 if(e.target.matches('input')){
   syncCards();
   if(e.target.value==='ipaduse::gaming_ipad')renderSelections();
 }
});

function card(value,name,sub=''){
 const icon=itemIconMarkup(name,'card');
 return `<label class="choice choice--with-icon" data-name="${name.toLowerCase()}"><input type="checkbox" value="${value}">${icon}<span class="pf-dr-choice-copy"><strong>${name}</strong>${sub?`<small>${sub}</small>`:''}</span><span class="tick"></span></label>`;
}
function filterCards(input,id){let q=input.value.toLowerCase();finderRoot.querySelectorAll('#'+id+' .choice').forEach(c=>c.style.display=c.dataset.name.includes(q)?'flex':'none')}

function alphaCompare(a,b){
 return String(a||'').localeCompare(String(b||''),undefined,{sensitivity:'base'});
}

function uniqueAppNames(categories){
 const names=[];
 for(const cat of categories)for(const n of (DATA.appCategories[cat]||[]))if(!names.includes(n))names.push(n);
 return names.sort(alphaCompare);
}

function renderSelections(){
 const ints=selected('#intentGrid');let html='';let prior=selected('#selectionArea');
 for(const intent of ints){
   if(intent==='gaming'||intent==='ipad')continue;
   const cats=DATA.intentGroups[intent]||[];
   const names=uniqueAppNames(cats);
   if(!names.length)continue;
   const title={workstudy:'Work & Study',development:'Development',design:'Design',video:'Video',engineering:'Engineering & CAD'}[intent]||intent;
   html+=`<div class="section"><h3>${title}</h3><div class="choices pf-dr-icon-choices" id="grp-${intent}">`;
   for(const n of names)html+=card('app::'+n,n);
   html+='</div></div>';
 }
 if(ints.includes('gaming')){
   html+=`<div class="section"><h3>PC Games</h3><p class="hint">Select your games.</p><input class="search" placeholder="Search 25 games…" data-pf-dr-filter-target="grp-gaming"><div class="choices pf-dr-icon-choices" id="grp-gaming">`;
   for(const n of [...DATA.gameNames].sort(alphaCompare))html+=card('game::'+n,n);
   html+='</div></div>';
 }
 if(ints.includes('ipad')){
   html+=`<div class="section"><h3>How will you use the iPad?</h3><div class="choices pf-dr-icon-choices" id="ipad-use-grid">`;
   for(const id of DATA.ipadUses){
     const item=DATA.ipadAll[id];
     html+=card('ipaduse::'+id,item.name);
   }
   html+='</div></div>';
   if(prior.includes('ipaduse::gaming_ipad')){
     html+=`<div class="section"><h3>Which iPad games?</h3><p class="hint">Select your games.</p><input class="search" placeholder="Search iPad games…" data-pf-dr-filter-target="ipad-game-grid"><div class="choices pf-dr-icon-choices" id="ipad-game-grid">`;
     const sortedIpadGames=[...DATA.ipadGames].sort((a,b)=>alphaCompare(DATA.ipadAll[a].name,DATA.ipadAll[b].name));
     for(const id of sortedIpadGames)html+=card('ipadgame::'+id,DATA.ipadAll[id].name);
     html+='</div></div>';
   }
 }
 selectionArea.innerHTML=html;
 finderRoot.querySelectorAll('#selectionArea input[type=checkbox]').forEach(x=>{if(prior.includes(x.value))x.checked=true});
 syncCards();
}

function selectedItems(){
 return selected('#selectionArea')
   .map(v=>{let [kind,...parts]=v.split('::');return {kind,name:parts.join('::')}})
   .filter(x=>x.kind==='app'||x.kind==='game');
}
function selectedIpadItems(){
 return selected('#selectionArea')
   .map(v=>{let [kind,...parts]=v.split('::');return {kind,id:parts.join('::')}})
   .filter(x=>x.kind==='ipaduse'||x.kind==='ipadgame');
}

function currentSelectionItem(name){
 return `<span class="pf-dr-current-selection__item" title="${escapeAssetAttribute(name)}" aria-label="${escapeAssetAttribute(name)}">
   ${itemIconMarkup(name,'reco')}
   <span class="pf-dr-current-selection__name">${name}</span>
 </span>`;
}

function renderCurrentSelections(){
 if(!loadSelections||!loadSelectionItems)return;

 const names=[];
 selectedItems().forEach(item=>{
   if(!names.includes(item.name))names.push(item.name);
 });

 selectedIpadItems().forEach(item=>{
   const entry=DATA.ipadAll[item.id];
   if(entry&&!names.includes(entry.name))names.push(entry.name);
 });

 loadSelectionItems.innerHTML=names.map(currentSelectionItem).join('');
 loadSelections.hidden=names.length===0;
}

function workloadKeysForSelection(){
 const items=selectedItems(),keys=[];
 for(const item of items){
   if(item.kind==='game'){if(!keys.includes('gaming'))keys.push('gaming');continue}
   const key=DATA.appWorkloadKeyByName[item.name];
   if(key&&!keys.includes(key))keys.push(key);
 }
 if(selectedIpadItems().length&&!keys.includes('ipad'))keys.push('ipad');
 return keys;
}
function renderLoads(){
 renderCurrentSelections();
 const keys=workloadKeysForSelection();let html='';
 const titles={workstudy:'Work & Study',development:'Development',design:'Design',video:'Video',engineering:'Engineering & CAD',gaming:'Gaming',ipad:'iPad'};
 for(const key of keys){
   const desc=DATA.workloadDesc[key],levels=LEVEL_LABELS[key];
   html+=`<div class="section"><h3>${titles[key]} level</h3><div class="radios" data-load="${key}">`;
   for(let i=0;i<3;i++)html+=`<label class="radio"><input type="radio" name="load-${key}" value="${levels[i]}" ${i===1?'checked':''}><strong>${desc[i][0]}</strong><span>${desc[i][1]}</span></label>`;
   html+='</div></div>';
 }
 loadArea.innerHTML=html;syncCards();
}
function loads(){let o={};finderRoot.querySelectorAll('[data-load]').forEach(g=>{let x=g.querySelector('input:checked');if(x)o[g.dataset.load]=x.value});return o}

function displayTiers(tiers){
 const labels={base:'Base',recommended:'Recommended',performance:'Performance'};
 const out=[],seen=new Set();
 for(const tier of TIERS){
   const band=(tiers[tier]||'').trim();
   if(!band||seen.has(band))continue;
   out.push({tier,label:labels[tier],band});
   seen.add(band);
 }
 return out;
}

function affordableActionLabel(candidate){
 if(candidate.action==='intensity'){
   return `Use ${candidate.name} at ${candidate.toLevel} intensity`;
 }

 return `Without ${candidate.name}`;
}

function copyFor(platform,tier,records){
 if(platform==='ipad'){
   if(tier==='base')return "Meets your selected iPad needs.";
   if(tier==='recommended')return "Best balance of performance and rental value.";
   return "More performance for demanding use and extra headroom.";
 }
 const gamingOnly=records.every(r=>r.kind==='game');
 if(platform==='windows'&&gamingOnly){
   if(tier==='base')return "Meets the needs of your selected games.";
   if(tier==='recommended')return "Best balance of gaming performance and rental value.";
   return "More performance for higher settings and frame rates.";
 }
 if(platform==='mac'){
   if(tier==='base')return "Meets your selected requirements.";
   if(tier==='recommended')return "Best balance of performance and rental value.";
   return "More performance and extra headroom.";
 }
 if(tier==='base')return "Meets your selected requirements.";
 if(tier==='recommended')return "Best balance of performance and rental value.";
 return "More performance for demanding work and extra headroom.";
}

function resultCard(x,platform,records,highlightTier='recommended'){
 const isHighlighted=x.tier===highlightTier;
 const isPerformance=x.tier==='performance';
 const star=x.tier==='recommended'&&highlightTier==='recommended'?'<span class="pf-dr-result-star" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M12 3.25l1.86 5.33a2.45 2.45 0 0 0 1.56 1.56L20.75 12l-5.33 1.86a2.45 2.45 0 0 0-1.56 1.56L12 20.75l-1.86-5.33a2.45 2.45 0 0 0-1.56-1.56L3.25 12l5.33-1.86a2.45 2.45 0 0 0 1.56-1.56L12 3.25Z"/></svg></span>':'';
 const href=recommendationProductUrlForBand(x.band);
 const linkAttrs=href?` href="${escapeAssetAttribute(href)}" aria-label="Rent ${escapeAssetAttribute(x.band)}"`:'';
 const tag=href?'a':'div';
 const isBusiness=/^Business Laptop —/i.test(String(x.band||''));
 return `<${tag} class="result pf-dr-recommend-segment${isHighlighted?' is-highlighted rec':''}${isPerformance?' perf':''}${isBusiness?' pf-dr-segment--business':''}${href?' pf-dr-result-link':''}"${linkAttrs} data-pf-dr-band="${escapeAssetAttribute(x.band)}"><div class="pf-dr-result-badge"><span class="pf-dr-result-badge__text">${x.label}</span>${star}</div><h4>${x.band}</h4><div class="pf-dr-monthly-price" hidden></div><p>${copyFor(platform,x.tier,records)}</p><div class="pf-dr-stock-status" hidden></div></${tag}>`;
}

function affordableResultCard(x,platform,records,highlightTier='recommended'){
 const isHighlighted=x.tier===highlightTier;
 const star=x.tier==='recommended'&&highlightTier==='recommended'?'<span class="pf-dr-affordable-tier__star" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M12 3.25l1.86 5.33a2.45 2.45 0 0 0 1.56 1.56L20.75 12l-5.33 1.86a2.45 2.45 0 0 0-1.56 1.56L12 20.75l-1.86-5.33a2.45 2.45 0 0 0-1.56-1.56L3.25 12l5.33-1.86a2.45 2.45 0 0 0 1.56-1.56L12 3.25Z"/></svg></span>':'';
 const href=recommendationProductUrlForBand(x.band);
 const linkAttrs=href?` href="${escapeAssetAttribute(href)}" aria-label="Rent ${escapeAssetAttribute(x.band)}"`:' role="group"';
 const tag=href?'a':'div';
 const isBusiness=/^Business Laptop —/i.test(String(x.band||''));
 const knownPrice=Number(x.afterPriceCents);
 const knownPriceDevice=String(
   x.priceDeviceName||recommendationDeviceForBand(x.band)||''
 );
 const formattedPrice=Number.isFinite(knownPrice)
   ?formatRecommendationMonthlyPrice(knownPrice)
   :'';
 const priceAttrs=Number.isFinite(knownPrice)&&knownPriceDevice
   ?` data-pf-dr-affordable-price-cents="${knownPrice}" data-pf-dr-affordable-price-device="${escapeAssetAttribute(knownPriceDevice)}"`
   :'';
 const priceMarkup=formattedPrice
   ?`<div class="pf-dr-monthly-price pf-dr-monthly-price--affordable"><strong>${formattedPrice}</strong><span>/ month</span></div>`
   :'<div class="pf-dr-monthly-price pf-dr-monthly-price--affordable" hidden></div>';

 return `<${tag} class="pf-dr-affordable-segment${isHighlighted?' is-highlighted':''}${isBusiness?' pf-dr-segment--business':''}${href?' pf-dr-result-link':''}"${linkAttrs} data-pf-dr-band="${escapeAssetAttribute(x.band)}"${priceAttrs}>
   <div class="pf-dr-affordable-tier"><span>${x.label}</span>${star}</div>
   <h4>${x.band}</h4>
   <div class="pf-dr-stock-status" hidden></div>
   ${priceMarkup}
 </${tag}>`;
}

function platformIconMarkup(platform,size='main'){
 const sizeClass=size==='compact'?' pf-dr-platform-icon--compact':'';

 if(platform==='windows'){
   return `<span class="pf-dr-platform-icon${sizeClass}" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M2.5 4.2 10.7 3v8.2H2.5V4.2Zm9.6-1.4L21.5 1.5v9.7h-9.4V2.8ZM2.5 12.6h8.2v8.2l-8.2-1.2v-7Zm9.6 0h9.4v9.9l-9.4-1.4v-8.5Z"/></svg></span>`;
 }

 if(platform==='mac'){
   return `<span class="pf-dr-platform-icon pf-dr-platform-icon--mac${sizeClass}" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.9 12.15c-.02-2.12 1.73-3.15 1.81-3.2-1-1.47-2.56-1.67-3.11-1.69-1.31-.14-2.59.79-3.26.79-.68 0-1.71-.77-2.81-.75-1.42.02-2.75.85-3.48 2.12-1.51 2.61-.38 6.45 1.06 8.56.72 1.03 1.56 2.18 2.67 2.14 1.08-.04 1.49-.69 2.8-.69 1.3 0 1.68.69 2.81.66 1.17-.02 1.9-1.03 2.6-2.07.83-1.18 1.16-2.35 1.18-2.41-.03-.01-2.24-.86-2.26-3.46Z"/><path d="M14.75 5.87c.58-.73.98-1.73.87-2.72-.84.04-1.89.58-2.49 1.29-.53.63-1 1.67-.88 2.62.95.07 1.91-.48 2.5-1.19Z"/></svg></span>`;
 }

 return '';
}

function platformHeadingMarkup(title,platform){
 return `<span class="pf-dr-platform-heading">${platformIconMarkup(platform)}<span>${title}</span></span>`;
}

function platformBlock(title,platform,route,records){
 const list=displayTiers(route.tiers);
 return `<div class="platform"><h3>${platformHeadingMarkup(title,platform)}</h3><div class="pf-dr-affordable-strip pf-dr-recommend-strip pf-dr-affordable-strip--${Math.min(list.length,3)}">${list.map(x=>resultCard(x,platform,records)).join('')}</div></div>`;
}

function affordablePlatformCards(platform,items,records=[],highlightTier='recommended'){
 if(!Array.isArray(items)||!items.length)return '';

 return `<div class="pf-dr-affordable-strip pf-dr-affordable-strip--${Math.min(items.length,3)}">
   ${items.map(x=>affordableResultCard(x,platform,records,highlightTier)).join('')}
 </div>`;
}

function serverAffordableRows(candidates,records){
 if(!Array.isArray(candidates)||!candidates.length)return '';

 const rows=candidates.map(candidate=>{
   const strips=[];

   for(const platform of ['windows','mac','ipad']){
     const items=candidate.changedTiers?.[platform]||[];
     if(!items.length)continue;

     const highlightTier=platform==='ipad'
       ?(candidate.highlightTier||'recommended')
       :(candidate.highlights?.[platform]||'recommended');

     strips.push(
       affordablePlatformCards(
         platform,
         items,
         records,
         highlightTier
       )
     );
   }

   if(!strips.length)return '';

   return `<div class="save-card">
     <div class="pf-dr-affordable-intro">
       <div class="pf-dr-affordable-remove">
         ${itemIconMarkup(candidate.name,'mini')}
         <span>${affordableActionLabel(candidate)}</span>
       </div>
     </div>
     <div class="pf-dr-affordable-strips">${strips.join('')}</div>
   </div>`;
 }).filter(Boolean);

 return rows.join('');
}

function ipadSelectedIds(){
 return selectedIpadItems().map(x=>x.id);
}

function ipadIntensityLabel(level){
 return level==='light'?'Light':level==='moderate'?'Moderate':'Heavy';
}

function recommendationSelectionItem(name,intensity){
 return `<span class="pf-dr-reco-selection" title="${escapeAssetAttribute(name)} — ${escapeAssetAttribute(intensity)}" aria-label="${escapeAssetAttribute(name)} — ${escapeAssetAttribute(intensity)}">
   ${itemIconMarkup(name,'reco')}
   <span class="pf-dr-reco-selection__name">${name}</span>
   <span class="pf-dr-reco-selection__level">${intensity}</span>
 </span>`;
}

function renderRecommendationSelections(records,ipadIds,ls){
 if(!recommendationSelections)return;

 const items=[];
 records.forEach(r=>items.push(recommendationSelectionItem(r.name,r.level)));

 if(ipadIds.length){
   const ipadLevel=ipadIntensityLabel(ls.ipad||'moderate');
   ipadIds.forEach(id=>{
     const item=DATA.ipadAll[id];
     if(item)items.push(recommendationSelectionItem(item.name,ipadLevel));
   });
 }

 recommendationSelections.innerHTML=items.join('');
 recommendationSelections.hidden=items.length===0;
}
async function recommend(){
 await recommendationPricingReady;

 const requestItems=selectedItems();
 const ls=loads();
 const ipadIds=ipadSelectedIds();

 if(!requestItems.length&&!ipadIds.length){
   renderRecommendationSelections([],[],ls);
   results.innerHTML=`<div class="info alert">No selection found. Go back and choose at least one item.</div>`;
   gotoStep(4);
   return;
 }

 try{
   const response=await fetchServerRecommendation({
     items:requestItems,
     loads:ls,
     ipadIds,
     pricing:recommendationPricingPayload()
   });

   const records=requestItems.map(item=>{
     const level=item.kind==='game'
       ?(ls.gaming||'High Performance')
       :(ls[DATA.appWorkloadKeyByName[item.name]]||'Moderate');
     return {kind:item.kind,name:item.name,level};
   });

   renderRecommendationSelections(records,ipadIds,ls);

   let html='';
   let affordableRows='';

   if(records.length){
     const compatibility=response.compatibility||{};

     if(compatibility.valid===false){
       const winOnly=Array.isArray(compatibility.windowsOnly)
         ?compatibility.windowsOnly
         :[];
       const macOnly=Array.isArray(compatibility.macOnly)
         ?compatibility.macOnly
         :[];

       html+=`<div class="info alert"><strong>No single laptop platform supports every selection.</strong><br>`;
       if(winOnly.length)html+=`Windows only: ${[...new Set(winOnly)].join(', ')}.<br>`;
       if(macOnly.length)html+=`macOS-only: ${[...new Set(macOnly)].join(', ')}.`;
       html+='</div>';
     }else{
       if(response.windows){
         html+=platformBlock(
           records.every(r=>r.kind==='game')?'Windows Gaming':'Windows',
           'windows',
           response.windows,
           records
         );
       }

       if(response.mac){
         html+=platformBlock(
           'MacBook',
           'mac',
           response.mac,
           records
         );
       }
     }
   }

   if(response.ipad){
     html+=platformBlock('iPad','ipad',response.ipad,[]);
   }

   affordableRows+=serverAffordableRows(response.affordable,records);

   if(affordableRows){
     html+=`<div class="saver saver--simple"><h3>Want a more affordable option?</h3>${affordableRows}</div>`;
   }

   if(!records.length&&!response.ipad){
     html=`<div class="info alert">No recommendation was returned. Please review your selections and try again.</div>`;
   }

   results.innerHTML=html;
   gotoStep(4);
   alignRecommendationCardContents();
   refreshRecommendationInventory();
 }catch(error){
   console.error('Playforce recommendation service error:',error);
   results.innerHTML=`<div class="info alert"><strong>Unable to load recommendation.</strong><br>Please try again.</div>`;
   gotoStep(4);
 }
}

function gotoStep(n){
 step=n;
 finderRoot.setAttribute('data-pf-dr-step',String(n));
 finderRoot.querySelectorAll('.step').forEach(s=>s.classList.toggle('active',+s.dataset.step===n));

 if(heroAccent){
   if(n===4){
     heroAccent.style.background='#32d4ff';
   }else{
     heroAccent.style.background='';
   }
 }

 window.scrollTo({top:0,behavior:'smooth'});
}
function next(){
 if(step===1){
   if(!selected('#intentGrid').length){intentWarn.style.display='block';return}
   intentWarn.style.display='none';renderSelections();
 }
 if(step===2){
   if(!selected('#selectionArea').length){selectionWarn.style.display='block';return}
   selectionWarn.style.display='none';renderLoads();
 }
 gotoStep(Math.min(4,step+1));
}
function prev(){gotoStep(Math.max(1,step-1))}
function resetAll(){
 finderRoot.querySelectorAll('input').forEach(x=>x.checked=false);
 if(loadSelectionItems)loadSelectionItems.innerHTML='';
 if(loadSelections)loadSelections.hidden=true;
 if(recommendationSelections){
   recommendationSelections.innerHTML='';
   recommendationSelections.hidden=true;
 }
 syncCards();gotoStep(1)
}
function runAction(action) {
 if (action === 'next') next();
 else if (action === 'prev') prev();
 else if (action === 'recommend') recommend();
 else if (action === 'goto-3') gotoStep(3);
 else if (action === 'reset') resetAll();
}

function bindActionButtons() {
 finderRoot.querySelectorAll('[data-pf-dr-action]').forEach(function (button) {
   if (button.getAttribute('data-pf-dr-bound') === 'true') return;
   button.setAttribute('data-pf-dr-bound', 'true');
   button.addEventListener('click', function (event) {
     event.preventDefault();
     event.stopPropagation();
     runAction(button.getAttribute('data-pf-dr-action'));
   });
 });
}

function createRentalRedirectModal(){
 let modal=document.getElementById('PlayforceRentalRedirectModal');
 if(modal)return modal;

 modal=document.createElement('div');
 modal.id='PlayforceRentalRedirectModal';
 modal.className='pf-dr-redirect-modal';
 modal.hidden=true;
 modal.innerHTML=`
   <div class="pf-dr-redirect-modal__backdrop" data-pf-dr-modal-close></div>
   <div class="pf-dr-redirect-modal__dialog"
     role="dialog"
     aria-modal="true"
     aria-labelledby="PlayforceRentalRedirectModalTitle"
     aria-describedby="PlayforceRentalRedirectModalCopy"
     tabindex="-1">
     <button type="button"
       class="pf-dr-redirect-modal__close"
       data-pf-dr-modal-close
       aria-label="Close confirmation">×</button>

     <div class="pf-dr-redirect-modal__eyebrow">Playforce Rentals</div>
     <h2 id="PlayforceRentalRedirectModalTitle">Proceed to Rental</h2>

     <p id="PlayforceRentalRedirectModalCopy">
       Continue with
       <strong class="pf-dr-redirect-modal__device"></strong>
       selected. Review rental period, dates and rates on the next page.
     </p>

     <div class="pf-dr-redirect-modal__actions">
       <button type="button"
         class="pf-dr-redirect-modal__button pf-dr-redirect-modal__button--secondary"
         data-pf-dr-modal-close>Back</button>
       <button type="button"
         class="pf-dr-redirect-modal__button pf-dr-redirect-modal__button--primary"
         data-pf-dr-modal-confirm>Continue</button>
     </div>
   </div>`;

 document.body.appendChild(modal);

 let pendingUrl='';
 let previousFocus=null;

 function closeModal(){
   if(modal.hidden)return;

   modal.hidden=true;
   document.documentElement.classList.remove('pf-dr-modal-open');
   pendingUrl='';

   if(previousFocus&&typeof previousFocus.focus==='function'){
     previousFocus.focus({preventScroll:true});
   }
 }

 modal.querySelectorAll('[data-pf-dr-modal-close]').forEach(control=>{
   control.addEventListener('click',closeModal);
 });

 const confirmButton=modal.querySelector('[data-pf-dr-modal-confirm]');

 confirmButton.addEventListener('click',()=>{
   if(!pendingUrl)return;
   const url=pendingUrl;
   pendingUrl='';
   window.location.assign(url);
 });

 document.addEventListener('keydown',event=>{
   if(modal.hidden)return;

   if(event.key==='Escape'){
     event.preventDefault();
     closeModal();
     return;
   }

   if(event.key!=='Tab')return;

   const focusable=[
     ...modal.querySelectorAll(
       'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
     )
   ].filter(element=>!element.hidden);

   if(!focusable.length)return;

   const first=focusable[0];
   const last=focusable[focusable.length-1];

   if(event.shiftKey&&document.activeElement===first){
     event.preventDefault();
     last.focus();
   }else if(!event.shiftKey&&document.activeElement===last){
     event.preventDefault();
     first.focus();
   }
 });

 modal.openForRecommendation=(deviceName,url)=>{
   if(!url)return;

   previousFocus=document.activeElement;
   pendingUrl=url;

   modal.querySelector('.pf-dr-redirect-modal__device').textContent=
     deviceName||'this recommended option';

   modal.hidden=false;
   document.documentElement.classList.add('pf-dr-modal-open');

   requestAnimationFrame(()=>{
     confirmButton.focus({preventScroll:true});
   });
 };

 return modal;
}

const rentalRedirectModal=createRentalRedirectModal();

finderRoot.addEventListener('click',function(event){
 const link=event.target.closest('a.pf-dr-result-link[href]');
 if(!link||!finderRoot.contains(link))return;

 event.preventDefault();
 event.stopPropagation();

 const title=link.querySelector('h4');
 const deviceName=title
   ?title.textContent.trim()
   :(link.getAttribute('data-pf-dr-band')||'this recommended option');

 rentalRedirectModal.openForRecommendation(deviceName,link.href);
});

bindActionButtons();

finderRoot.addEventListener('input', function (event) {
 const input = event.target.closest('[data-pf-dr-filter-target]');
 if (!input || !finderRoot.contains(input)) return;
 filterCards(input, input.getAttribute('data-pf-dr-filter-target'));
});

syncCards();
finderRoot.setAttribute('data-pf-dr-step','1');
bindActionButtons();

if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', bindActionButtons, { once: true });
}

window.PlayforceDeviceRecommendation = {
  next: next,
  prev: prev,
  recommend: recommend,
  gotoStep: gotoStep,
  resetAll: resetAll,
  filterCards: filterCards
};

})();
